export function logout(redirect = true) {
  localStorage.removeItem("token");
  localStorage.removeItem("tokenExpiry");
  localStorage.removeItem("user");
  localStorage.removeItem("role");
  localStorage.removeItem("access");

  sessionStorage.removeItem("token");
  sessionStorage.removeItem("tokenExpiry");
  sessionStorage.removeItem("user");
  sessionStorage.removeItem("role");
  sessionStorage.removeItem("access");

  if (redirect) {
    window.location.replace("/");
  }
}

export function onErrorLogout() {
  logout();
  window.location.href = "/";
}

export function handleResponse(data) {
  console.log('data', data);
  if (!data) {
    throw new Error("No response data received");
  }

  if (data.error) {
    if (data.code === 3) {
      onErrorLogout();
    }
    if (data.code === 401) {
      onErrorLogout();
    }
    throw new Error(data.message || "An error occurred");
  }

  return data;
}
